import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'

import { ICalendarLeaveDaysResponse, IResponse } from '../models'

export const fetchHolidays = async () => {
  const [accessToken] = getTokens()
  const url = proxy('/webservice/535/sp/v4/spGACHolidaysList/call')

  const headers = new HttpHeaders()
  if (accessToken) {
    headers.add('Authorization', `Bearer ${accessToken}`)
  }

  const response = (await Rest.post({ url, headers })) as IResponse<ICalendarLeaveDaysResponse>

  return { Data: response.Data }
}
